import { render } from "./PopupEnableReading.vue?vue&type=template&id=f5140580&scoped=true"
import script from "./PopupEnableReading.vue?vue&type=script&lang=js"
export * from "./PopupEnableReading.vue?vue&type=script&lang=js"

import "./PopupEnableReading.vue?vue&type=style&index=0&id=f5140580&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5140580"]])

export default __exports__